export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";